import React from "react";
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {SpacerBox} from '../../../basic-ui-components/layout/spacer.box';
import {GeoModalWrapperBox} from '../boxes/geo-modal-wrapper.box';
import { DialogTextBox, DialogHighlightedTextBox } from "../../modal-dialog/boxes/text/dialog-text.box";

interface IGeoFreezePopupComponentProps {
    headerText1?: string;
    headerText2?: string;
}

export class GeoFreezePopupComponent extends OrbitComponent<IGeoFreezePopupComponentProps> {

    render() {

        const {headerText1,headerText2} = this.props;

        return (
            <GeoModalWrapperBox>
                {headerText1 && <DialogHighlightedTextBox>{headerText1}</DialogHighlightedTextBox>}
                {headerText2 && <DialogTextBox>{headerText2}</DialogTextBox>}
                {/* https://dev.azure.com/888holdings/GamingNDL/_workitems/edit/2019574 */}
                <SpacerBox height="3rem" />
            </GeoModalWrapperBox>
        );
    }
}
